import LocalizedStrings from 'react-localization';

export default new LocalizedStrings({
  en: {
    title: `Welcome to DaaS Portal!`,
    alreadyRedeemedPt1: `This email address already has an account. Please click`,
    alreadyRedeemedPt2: 'Here',
    alreadyRedeemedPt3: `to log in.`,
    createAccountSubmit: 'Create an account and get started'
  }
});
